import { InjectionToken } from '@angular/core';
import type { AuthModeResuelto } from './resolve-auth-config';

export interface AuthConfig {
  tokenStorageKey: string;
  authHeader: string;
  gatewayLoginUrl: string;
  tokenExchangeUrl: string;
  // Entra ID (FE-85/FE-86): ausente en los fixtures existentes, que siguen representando modo simulada.
  modo?: AuthModeResuelto;
  errorConfiguracion?: string;
}

export interface AppConfig {
  appName: string;
  apiBaseUrl: string;
  environment: 'dev' | 'qa' | 'uat' | 'prod';
  enableI18n: boolean;
  announcementBanner: string;
  panelDesarrolloLocalVisible: boolean;
  auth: AuthConfig;
}

export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG');
